import { useState } from 'react'
import { apiWrapper } from './dataHookUtils'
import useFetch from '../hooks/useFetch'
import useMe from '../hooks/useMe'
import useSnackbar from '../hooks/useSnackbar'

export default () => {
  const fetch = useFetch()

  const [isLoading, setIsLoading] = useState()
  const [implementation, setImplementation] = useState()

  const { userId } = useMe()
  const { newMessage } = useSnackbar()

  const fetchImplementation = async () => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/implementation?userId=${userId}`,
        options: {
          method: 'GET'
        }
      });
      setImplementation(result)
      return result
    } catch (e) {
      console.log(e)
      newMessage({ message: 'Error retrieving user implementation', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUserAccount = async (userId) => {
    return apiWrapper({
      fetch,
      url: `accounts/user?userId=${userId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchUserAccounts = async (accountId, implementationId, includePastImplementations) => {
    return apiWrapper({
      fetch,
      url: `accounts/users?accountId=${accountId}&implementationId=${implementationId}&includePastImplementations=${includePastImplementations}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    isLoading,
    implementation,
    fetchImplementation,
    fetchUserAccount,
    fetchUserAccounts
  }
}